<template>
  <v-autocomplete
    v-model="selectedItem"
    :label="label"
    :items="items"
    :dense="dense"
    return-object
    :loading="isFindServicePending"
    :search-input.sync="searchInput"
    :rules="rules"
    :placeholder="placeholder"
    :clearable="clearable"
    :disabled="disabled"
    :item-text="itemText"
  >
    <!-- pass through normal slots -->
    <template v-for="(_, name) in $slots" #[name]>
      <slot :name="name" />
    </template>

    <template #append-item v-if="!isFindServicePending && areMoreItems">
      <v-list-item @click="loadMore">
        <v-list-item-title>Load more...</v-list-item-title>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import { makeFindMixin } from "feathers-vuex";
import deepmerge from "deepmerge";

export default {
  name: "FeathersAutocomplete",
  components: {},
  mixins: [
    makeFindMixin({
      service() {
        return this.serviceName;
      },
      name: "service",
      watch: true,
    }),
  ],
  props: {
    serviceName: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    label: { type: String, required: true },
    dense: {
      type: Boolean,
      required: false,
      default: false,
    },
    limit: {
      type: Number,
      required: false,
      default: 20,
    },
    params: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    returnObject: {
      type: Boolean,
      required: false,
      default: false,
    },
    rules: { type: Array, required: false, default: () => [] },
    placeholder: { type: String, required: false, default: undefined },
    clearable: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false },
    itemValue: { type: String, required: false, default: "id" },
    itemText: { type: String, required: false, default: "text" },
  },
  data() {
    return {
      fetchedPages: 1,
      searchInput: "",
    };
  },
  computed: {
    slots() {
      return { slots: this.$slots, scopedSlots: this.$scopedSlots };
    },
    selectedItem: {
      get() {
        return this.returnObject
          ? this.value
          : this.items.find((v) => v[this.itemValue] === this.value);
      },
      set(val) {
        const value = this.returnObject ? val : val[this.itemValue];
        this.$emit("input", value);
      },
    },
    areMoreItems() {
      if (this.haveServiceLoadedOnce) {
        return this.items.length < this.serviceLatestQuery.response.total;
      }
      return false;
    },
    skip() {
      return this.limit * (this.fetchedPages - 1);
    },
    serviceFetchParams() {
      const pagination = {
        query: {
          $limit: this.limit,
          $skip: this.skip,
        },
        debounce: 500,
      };
      const merge = deepmerge(this.params, pagination);
      return merge;
    },
    serviceParams() {
      const pagination = {
        query: {},
      };
      const merge = deepmerge(this.params, pagination);
      return merge;
    },
    lastQueriedAt() {
      return this.servicePaginationData.default && this.servicePaginationData.default.mostRecent
        ? this.servicePaginationData.default.mostRecent.queriedAt
        : 0;
    },
  },
  watch: {
    lastQueriedAt() {
      this.$emit("update:items", this.items);
    },
    serviceError(v) {
      if (v) {
        this.$emit("serviceError", v);
      }
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadMore() {
      this.fetchedPages += 1;
      this.$emit("loadMore", this.searchInput);
    },
  },
};
</script>

<style></style>
